<template>
    <v-flex x16 class="sortable-handler">
    <v-card>
    <v-dialog v-model="showModal" hide-overlay transition="dialog-bottom-transition" class="sortable-handler">
          <v-card>
          <v-toolbar dark color="primary">
              <v-toolbar-side-icon></v-toolbar-side-icon>
              <v-toolbar-title>Summary of upload Devices</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items class="hidden-sm-and-down">
              <v-btn icon dark @click="closeModalCreate()">
                  <v-icon>close</v-icon>
              </v-btn>
              </v-toolbar-items>
          </v-toolbar>
          <v-layout row wrap class="pa-4">
              
              <v-flex xs12 >
              <v-card class="pa-2">
              <v-expansion-panel>
                <v-expansion-panel-content>
                  <div slot="header">Managers</div>
                  
                    <v-card>
                      <v-layout row wrap>
                        <v-flex xs6 class="pa-1">
                          <strong>Success</strong>    
                          <v-data-table
                            :headers="headers_managers"
                            :items="success_managers"
                            class="elevation-1"
                          >
                            <template slot="items" slot-scope="props">
                              <td :class="status(props.item.type)">{{ props.item.name }}</td>
                              <td :class="status(props.item.type)">{{ props.item.email }}</td>
                              <td :class="status(props.item.type)">{{ props.item.message }}</td>
                            </template>
                            <template slot="pageText" slot-scope="props">
                              Page {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}
                            </template>
                          </v-data-table>
                        </v-flex>
                        <v-flex xs6 class="pa-1">
                          <strong>Errors</strong>
                          <v-data-table
                            :headers="headers_managers"
                            :items="error_managers"
                            class="elevation-1"
                          >
                          <template slot="items" slot-scope="props">
                            <td :class="status(props.item.type)">{{ props.item.name }}</td>
                            <td :class="status(props.item.type)">{{ props.item.email }}</td>
                            <td :class="status(props.item.type)">{{ props.item.message }}</td>
                          </template>
                          <template slot="pageText" slot-scope="props">
                            Page {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}
                          </template>
                          </v-data-table>
                        </v-flex>
                      </v-layout> 
                    </v-card>
                                   
                </v-expansion-panel-content>
                <v-expansion-panel-content>
                  <div slot="header">Groups</div>
                  <v-card>
                    <v-layout row wrap>
                      <v-flex xs6 class="pa-1">
                        <strong>Success</strong>    
                        <v-data-table
                          :headers="headers_groups"
                          :items="success_groups"
                          class="elevation-1"
                        >
                          <template slot="items" slot-scope="props">
                            <td :class="status(props.item.type)">{{ props.item.name }}</td>
                            <td :class="status(props.item.type)">{{ props.item.message }}</td>
                          </template>
                          <template slot="pageText" slot-scope="props">
                            Page {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}
                          </template>
                        </v-data-table>
                      </v-flex>
                      <v-flex xs6 class="pa-1">
                        <strong>Errors</strong>
                        <v-data-table
                          :headers="headers_groups"
                          :items="error_groups"
                          class="elevation-1"
                        >
                        <template slot="items" slot-scope="props">
                          <td :class="status(props.item.type)">{{ props.item.name }}</td>
                          <td :class="status(props.item.type)">{{ props.item.message }}</td>
                        </template>
                        <template slot="pageText" slot-scope="props">
                          Page {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}
                        </template>
                        </v-data-table>
                      </v-flex>
                    </v-layout> 
                  </v-card>
                </v-expansion-panel-content>
                <v-expansion-panel-content>
                  <div slot="header">Devices</div>
                  <v-card>
                    <v-layout row wrap>
                      <v-flex xs6 class="pa-1">
                        <strong>Success</strong>    
                        <v-data-table
                          :headers="headers_devices"
                          :items="success_devices"
                          class="elevation-1"
                        >
                          <template slot="items" slot-scope="props">
                            <td :class="status(props.item.type)">{{ props.item.name }}</td>
                            <td :class="status(props.item.type)">{{ props.item.message }}</td>
                          </template>
                          <template slot="pageText" slot-scope="props">
                            Page {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}
                          </template>
                        </v-data-table>
                      </v-flex>
                      <v-flex xs6 class="pa-1">
                        <strong>Errors</strong>
                        <v-data-table
                          :headers="headers_devices"
                          :items="error_devices"
                          class="elevation-1"
                        >
                        <template slot="items" slot-scope="props">
                          <td :class="status(props.item.type)">{{ props.item.name }}</td>
                          <td :class="status(props.item.type)">{{ props.item.message }}</td>
                        </template>
                        <template slot="pageText" slot-scope="props">
                          Page {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}
                        </template>
                        </v-data-table>
                      </v-flex>
                    </v-layout> 
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>              
              </v-card>
              </v-flex>
          </v-layout>
          </v-card>
    </v-dialog>
    </v-card>
    </v-flex>
</template>
<script>

export default {
  props: {
    items: {
      type: Object,
      required: false,
      default: null,
    }
  },
  data () {
    return {
      showModal: true,
      headers_managers: [
        {
          text: 'Name',
          align: 'left',
          sortable: true,
          value: 'name'
        },
        { text: 'Email', value: 'email' },
        { text: 'Message', value: 'Message' }  
      ],
      success_managers: [],
      error_managers: [],
      headers_groups: [
        {
          text: 'Name',
          align: 'left',
          sortable: true,
          value: 'name'
        },
        { text: 'Message', value: 'Message' }  
      ],
      success_groups: [],
      error_groups: [],
      headers_devices: [
        {
          text: 'Name',
          align: 'left',
          sortable: true,
          value: 'name'
        },
        { text: 'Message', value: 'Message' }  
      ],
      success_devices: [],
      error_devices: [],
    };
  },
  computed: {
    
  },
  mounted () {
    this.loadData();
  },
  methods: {
    closeModalCreate () {
      this.$emit('closeModal');
    },
    status (item) {
      if (item === 'warning') {
        return 'warning-status';
      }
      if (item === 'danger') {
        return 'danger-status';
      }
      if (item === 'success') {
        return 'success-status';
      }
      return '';
    },
    loadData () {
      this.success_managers = this.items.sucessfully_managers;
      this.error_managers = this.items.errors_managers;
      this.success_groups = this.items.sucessfully_groups.concat(this.items.sucessfully_group_managers);
      this.error_groups = this.items.errors_groups.concat(this.items.errors_group_managers);
      this.success_devices = this.items.sucessfully_devices;
      this.error_devices = this.items.errors_devices;
    }
  }
};
</script>
<style>
  .d-flex{
    display: flex;
  }
  .text-center{
    text-align: center;
  }
  .color{
    display: block;
    width: 50px;
    height: 20px;
  }
  .sortable-handler {
    touch-action: none;
  }
  .danger-status {
    background-color: #FFCDD2;
  }
  .success-status {
    background-color: #C8E6C9;
  }
  .warning-status {
    background-color: #F0F4C3;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/devices/ModalSummary.vue